var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonOutlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.66667C8.52667 4.66667 7.33333 5.86001 7.33333 7.33334C7.33333 8.80667 8.52667 10 10 10C11.4733 10 12.6667 8.80667 12.6667 7.33334C12.6667 5.86001 11.4733 4.66667 10 4.66667ZM11.4 7.33334C11.4 6.56 10.7733 5.93334 10 5.93334C9.22667 5.93334 8.6 6.56 8.6 7.33334C8.6 8.10667 9.22667 8.73334 10 8.73334C10.7733 8.73334 11.4 8.10667 11.4 7.33334ZM14.0667 13.3333C14.0667 12.9067 11.98 11.9333 10 11.9333C8.02 11.9333 5.93333 12.9067 5.93333 13.3333V14.0667H14.0667V13.3333ZM4.66667 13.3333C4.66667 11.56 8.22 10.6667 10 10.6667C11.78 10.6667 15.3333 11.56 15.3333 13.3333V15.3333H4.66667V13.3333Z",
    fill: "#0F172A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutlineIcon);
export default __webpack_public_path__ + "static/media/PersonOutlineIcon.178c9b6c1479f8a76002bdc77355ea4d.svg";
export { ForwardRef as ReactComponent };